import { render, staticRenderFns } from "./NovaLista.vue?vue&type=template&id=5e7bb9d0"
import script from "./NovaLista.vue?vue&type=script&lang=js"
export * from "./NovaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports